define.alias("shared/utils/number-helpers/ratio-to-percent", "settings/utils/number-helpers/ratio-to-percent");